import { authedFetch } from "../api/authedFetch";
const OWNER_KEY = "swim-lab:owner-oid";
async function fetchJson(url, init) {
    const res = await authedFetch(url, init);
    if (!res.ok)
        throw new Error(`${url} → ${res.status}`);
    return res.json();
}
export async function syncOnLogin(currentOid, dataStore) {
    const previousOwner = localStorage.getItem(OWNER_KEY);
    // Fetch server state first. If we can't reach the server (offline, transient
    // failure), bail out before touching local data — that way an offline launch
    // still has the previous session's cache to fall back on.
    let serverSwimmers;
    let serverData;
    try {
        serverSwimmers = await fetchJson("/api/user/swimmers");
        serverData = await fetchJson("/api/user/data");
    }
    catch (err) {
        console.warn("[syncOnLogin] server unreachable, keeping local cache", err);
        return;
    }
    if (previousOwner && previousOwner !== currentOid) {
        await dataStore.clear();
    }
    const localSwimmers = await dataStore.getAllSwimmers().catch(() => []);
    const localStore = await dataStore.loadCountyTimesStore().catch(() => ({}));
    const localStandards = await dataStore.loadActiveStandards().catch(() => []);
    if (serverSwimmers.length === 0 && localSwimmers.length > 0) {
        for (const s of localSwimmers) {
            await fetchJson(`/api/user/swimmers/${encodeURIComponent(s.tiref)}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(s),
            });
        }
    }
    else {
        await dataStore.replaceAllSwimmers(serverSwimmers);
    }
    const serverHasData = Object.keys(serverData.countyTimesStore).length > 0 || serverData.activeStandards.length > 0;
    const localHasData = Object.keys(localStore).length > 0 || localStandards.length > 0;
    if (!serverHasData && localHasData) {
        await fetchJson("/api/user/data", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ countyTimesStore: localStore, activeStandards: localStandards }),
        });
    }
    else {
        await dataStore.saveCountyTimesStore(serverData.countyTimesStore);
        await dataStore.saveActiveStandards(serverData.activeStandards);
    }
    localStorage.setItem(OWNER_KEY, currentOid);
}
export async function clearLocalData(dataStore) {
    await dataStore.clear();
    localStorage.removeItem(OWNER_KEY);
}
